// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2DAZO","header":"PatientBlock_header__23B3R","label":"PatientBlock_label__2Ci8W","option":"PatientBlock_option__2Tg7a"};